export default __webpack_public_path__ + "static/media/warning-red.0d19c537.svg";